import React from "react";
import { useHistory } from "react-router-dom";
import ChatContent from "../../components/chatComponent/ChatContent";
import ListCustomer from "../../components/chatComponent/ListCustomer";
import { CardSummary } from "../../components/databaseAdminComponent/CardSummary";
import { GetErrorMessage } from "../../functions/error";
import { IPaymentTracking } from "../../interfaces/paymentTracking";
import { getBookingWithDoctorId } from "../../services/booking.service";
import { useError } from "../../store/ErrorModal";
import { useUser } from "../../store/UserStore";
import { Container } from "./index.style";
export default function ChatPage() {
  const [data, setData] = React.useState<IPaymentTracking[]>([]);
  const [dataCard, setDataCard] = React.useState<IPaymentTracking>();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const { userData } = useUser();
  const { onError } = useError();
  const history = useHistory();

  const fetchData = React.useCallback(async () => {
    if (!userData?.uid) return history.replace("/login/");
    setIsLoading(true);
    try {
      const res = await getBookingWithDoctorId(userData?.uid);
      setDataCard(res.data[0]);
      setData(res.data);
    } catch (error) {
      onError(GetErrorMessage(error));
    }
    setIsLoading(false);
  }, [userData?.uid, onError, history]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);
  const handleChangeTage = async (tags: string[]) => {
    const nData = data.map((item) => {
      if (item.bookingId === dataCard?.bookingId)
        return { ...dataCard, summaryTags: tags };
      else return item;
    });
    setData(nData);
  };
  const handleSubmit = async () => {
    const nData = data.filter((item) => item.bookingId !== dataCard?.bookingId);
    setDataCard(nData[0]);
    setData(nData);
  };

  return (
    <Container>
      <ListCustomer
        onChangeBooking={(booking) => setDataCard(booking)}
        listBookings={data}
      />
      <ChatContent booking={dataCard} />
      <CardSummary
        isLoading={isLoading}
        booking={dataCard}
        handleSubmit={handleSubmit}
        handleChangeTage={handleChangeTage}
      />
    </Container>
  );
}
